// NAV scroll
(function() {
  var nav = document.getElementById('navbar');
  if (!nav) return;
  function onScroll() {
    if (window.scrollY > 80) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// TICKER (uses available products from window.tickerItems if injected, else default)
(function() {
  var track = document.getElementById('tickerTrack');
  if (!track) return;
  var items = window.tickerItems || [
    'Factory Sealed · Tracked Shipping · Ships in 24h',
    'Arrive-Sealed Guarantee · Authorized Distributors Only',
    'Pokémon · Football · Baseball — All Sealed',
    'Real Collector. Real Photos. Real Refunds.',
    'No Resealed Product · No Scalper Markups · Ever',
    'Sealed Boxes · No Compromise',
  ];
  track.innerHTML = items.concat(items).map(function(t) {
    return '<span class="ticker-item"><span class="ticker-dot"></span>' + t + '</span>';
  }).join('');
})();
